import { sortThreads } from '../../components/messenger/helper'

function messengerAddMessage(state, message) {
    return {
        ...state,
        messages: {
            ...state.messages,
            ...message,
        },
    }
}

function messengerSetMessages(state, messages) {
    return {
        ...state,
        messages: messages,
    }
}

function messengerClearMessages(state, threadSlug = null) {
    if (threadSlug) {
        return {
            ...state,
            messages: {},
            threads: {
                ...state.threads,
                [threadSlug]: {
                    ...state.threads[threadSlug],
                    messages: [],
                },
            },
        }
    }

    return {
        ...state,
        messages: {},
    }
}

function messengerAddThread(state, thread) {
    return {
        ...state,
        threads: {
            ...state.threads,
            ...thread,
        },
    }
}

function messengerSetThreads(state, threads) {
    return {
        ...state,
        threads: sortThreads(threads),
    }
}

function messengerClearThreads(state) {
    return {
        ...state,
        threads: {},
    }
}

function messengerSetUsers(state, users) {
    return {
        ...state,
        users,
    }
}

function messengerSetParticipants(state, participants) {
    return {
        ...state,
        participants,
    }
}

function messengerSetUnreadMessagesCount(state, count) {
    return {
        ...state,
        unreadMessagesCount: parseInt(count, 10),
    }
}

function messengerSetLastSeen(state, lastSeen) {
    return {
        ...state,
        lastSeen: {
            ...state.lastSeen,
            [lastSeen.thread_slug]: lastSeen,
        },
    }
}


function messengerSetBusySend(state, busy = false) {
    return {
        ...state,
        busySend: busy,
    }
}

export default function (state = [], action) {
    switch (action.type) {
        case 'MESSENGER_ADD_MESSAGE': return messengerAddMessage(state, action.message)
        case 'MESSENGER_CLEAR_MESSAGES': return messengerClearMessages(state, action.threadSlug)
        case 'MESSENGER_SET_MESSAGES': return messengerSetMessages(state, action.messages)
        case 'MESSENGER_ADD_THREAD': return messengerAddThread(state, action.thread)
        case 'MESSENGER_CLEAR_THREADS': return messengerClearThreads(state)
        case 'MESSENGER_SET_THREADS': return messengerSetThreads(state, action.threads)
        case 'MESSENGER_SET_USERS': return messengerSetUsers(state, action.users)
        case 'MESSENGER_SET_PARTICIPANTS': return messengerSetParticipants(state, action.participants)
        case 'MESSENGER_SET_UNREAD_MESSAGES_COUNT': return messengerSetUnreadMessagesCount(state, action.count)
        case 'MESSENGER_SET_LAST_SEEN': return messengerSetLastSeen(state, action.lastSeen)
        case 'MESSENGER_SET_BUSY_SEND': return messengerSetBusySend(state, action.busy)
        default: return state
    }
}
